import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';

import { isB2C } from '@/core/settings/utils';
import { NavigationButton } from '@/core/tamagoshiTailwind/components/NavigationButton/NavigationButton';
import { SectionButton } from '@/core/tamagoshiTailwind/components/SectionButton/SectionButton';
import { SymbolB2CIcon } from '@/core/tamagoshiTailwind/icons/SymbolB2CIcon';
import { Gtm } from '@/core/tracking/utils/Gtm';
import { leonidasLinkAdvice } from '@/productDiscovery/HeaderLeonidas/b2c/modules/translations';
import { getFamilyIcon } from '@/productDiscovery/HeaderLeonidas/components/Menu/components/FamilyIcon/familyIcon';
import { setSelectedFamily } from '@/productDiscovery/HeaderLeonidas/HeaderLeonidas.actions';
import type { MenuCategory } from '@/productDiscovery/HeaderLeonidas/interfaces/MenuTree.model';
import {
  GTM_CLICK_ON_A_LINK,
  GTM_CLICK_ON_MENU_ITEM,
} from '@/productDiscovery/HeaderLeonidas/services/tracking/gtmEvents';
import { footerSitemapAdviceHref } from '@/retention/Footer/translations';

interface MenuFamiliesProps {
  families?: MenuCategory[];
}

export const MenuFamilies: FunctionComponent<MenuFamiliesProps> = ({
  families,
}: MenuFamiliesProps) => {
  const dispatch = useDispatch();

  const select = (event: React.MouseEvent, family: MenuCategory) => {
    const menuItem = {
      categoryName: family.name,
      subCategoryName: '',
      subSubCategoryName: '',
      url: family.url,
      level: 0,
    };
    dispatch(setSelectedFamily(family));
    Gtm.push(GTM_CLICK_ON_MENU_ITEM(menuItem));
    event.stopPropagation();
  };

  return (
    <ul className="absolute h-full w-full">
      <li
        className="h-[64px] w-full content-center border-b
          border-foundation-primary pl-m pr-xxxl"
      >
        {isB2C() && (
          <NavigationButton
            text={leonidasLinkAdvice}
            variant="link"
            icon={SymbolB2CIcon}
            href={footerSitemapAdviceHref}
            size="M"
            onClick={() =>
              Gtm.push(
                GTM_CLICK_ON_A_LINK(
                  footerSitemapAdviceHref,
                  leonidasLinkAdvice,
                ),
              )
            }
          />
        )}
      </li>
      <div className="h-[calc(100%-64px)] overflow-y-auto">
        {families?.map((family) => (
          <li key={family.id} data-testid="menu-family-item">
            <SectionButton
              icon={getFamilyIcon(Number(family.id))}
              onClick={(e) => select(e, family)}
              title={family.name}
            />
          </li>
        ))}
      </div>
    </ul>
  );
};
